import { createSlice } from "@reduxjs/toolkit";
import { User } from "../../../../entities/User";
import { loginUserUseCase } from "../../../../usecases/UserUseCases/loginUserUseCase";
import { userApi } from "../../../api/userApi";
import {notification} from "antd";
import Cookies from 'js-cookie';
import { clearAuthSession } from "../../../../utils/authSession";
const userSlice = createSlice({
  name: "user",
  initialState: {
    _id: null,
    email: null,
    name: null,
    username: null,
    dp: null,
    role: null,
    mobileNumber: null,
    fcmToken: null,
    error:null
  },
  reducers: {
    loginUserFullfilled: (state, action) => {
      let user = action.payload;
      let userEntity = new User(
        user._id,
        user.email,
        user.name,
        user.username,
        user.dp,
        user.role,
        user.mobileNumber,
        user.fcmToken
      )
      state._id=userEntity._id;
      state.email=userEntity.email;
      state.name=userEntity.name;
      state.username=userEntity.username;
      state.dp=userEntity.dp;
      state.role=userEntity.role;
      state.mobileNumber=userEntity.mobileNumber;
      state.fcmToken=userEntity.fcmToken;
    },
    loginUserRejected: (state, action) => {
      state.error = action.payload;
    },
    logoutUser: (state) => {
      state._id=null;
      state.email=null;
      state.name=null;
      state.username=null;
      state.dp=null;
      state.role=null;
      state.mobileNumber=null;
      state.fcmToken=null;
    }
  }
});

export const { loginUserFullfilled, loginUserRejected, logoutUser } = userSlice.actions;
export default userSlice.reducer

export const loginUserThunk = (values) => async (dispatch) => {
  try {
    if (process.env.NODE_ENV === "development") {
      await clearAuthSession();
    }

    const response = await loginUserUseCase(userApi, values);

    if (response.error) {
      notification.error({ message: response.error.message });
      dispatch(loginUserRejected(response.error.message));
      return;
    }

    if (!response.userData || !response.token) {
      const message = "Unable to sign in. Please try again.";
      notification.error({ message });
      dispatch(loginUserRejected(message));
      return;
    }

    dispatch(loginUserFullfilled(response.userData));
    localStorage.setItem("token", response.token);
    Cookies.set("auth", response.token, { expires: 7 });
  } catch (error) {
    dispatch(loginUserRejected(error.message));
    notification.error({ message: error.message || "Failed to sign in" });
  }
};

export const logoutUserThunk = () => async (dispatch) => {
  await clearAuthSession();
  dispatch(logoutUser());
};
